/**
 * Closes patient list row action menus portaled to document.body (ngbDropdown container="body").
 * Call before opening a modal so menus do not render above the dialog.
 */
export function closeOpenRowActionDropdownMenus(): void {
  const openMenuSelector = [
    'body > .dropdown-menu.show',
    '.patient-action-menu.show',
    '.recall-list-actions-menu.show',
    '.prescription-action-menu.show',
    '.treatment-plan-actions-menu.show',
    '.bill-actions-menu.show',
    '.mmp-row-actions-menu.show',
  ].join(', ');

  document.querySelectorAll(openMenuSelector).forEach((menuNode) => {
    menuNode.classList.remove('show');

    if (menuNode instanceof HTMLElement) {
      menuNode.style.removeProperty('display');
      menuNode.setAttribute('aria-hidden', 'true');
    }
  });

  document.querySelectorAll(
    '.mmp-row-actions-dropdown.show, .patient-action-dropdown.show, .dropdown.show'
  ).forEach((dropdownNode) => {
    dropdownNode.classList.remove('show');
  });

  document.querySelectorAll(
    '[ngbdropdowntoggle][aria-expanded="true"], [ngbDropdownToggle][aria-expanded="true"], .dropdown-toggle[aria-expanded="true"]'
  ).forEach((toggleNode) => {
    toggleNode.setAttribute('aria-expanded', 'false');
  });
}
